module.exports = __webpack_public_path__ + "static/media/Img220819.1e50930b.jpg";